module.exports = __webpack_public_path__ + "img/bz.422abd24.svg";